
<template>

    <div class="container">
        <h2 class="text-center title">  {{ $t('home.advocacy_pillar.title') }}</h2>
        <div class=" d-flex flex-row justify-content-center align-items-center mt-4">
            <button class="btn btn-primary ms-2 me-2">  {{ $t('home.advocacy_pillar.all') }}</button>
            <button class="btn btn-outline-primary ms-2 me-2">  {{ $t('home.advocacy_pillar.images') }}</button>
            <button class="btn btn-outline-primary">  {{ $t('home.advocacy_pillar.videos') }}</button>
        </div>
        <h4 class="view-all">  {{ $t('home.advocacy_pillar.show_all') }}</h4>
        <ImagesSlider :videoGallery="videoGallery"/>
    </div>
</template>

<script>
import ImagesSlider from './advocacypillar/ImagesSlider.vue';


export default {
    props : ['videoGallery'],
    components : {
        ImagesSlider
    }
}
</script>


<style scoped>
.container {
    margin-top: 40px;
}

.title {
    font-size: 36px;
    font-weight: 500;
}

.btn {
    height: 48px;
}

.view-all {
    font-size: 20px;
    font-weight: 500;
    color: #BF9F35;
    /* Gold color */
    text-decoration: none;
    float: inline-end;
    text-decoration: underline;
    cursor: pointer;
}


</style>